import classNames from 'classnames';
import { XCircle } from 'react-feather';
var classes = {
    base: 'cursor-pointer rounded-lg flex items-center gap-1 flex-shrink-0 px-3 py-2 text-xs transition-opacity md:hover:opacity-60',
    classic: 'border border-secondary-01',
    more: 'bg-secondary-04 border-transparent',
    selected: 'bg-brand-01 text-white md:hover:opacity-60',
    disabled: 'pointer-events-none opacity-50',
};
var MultiSelectFullCategory = function (_a) {
    var category = _a.category, onClick = _a.onClick, _b = _a.more, more = _b === void 0 ? false : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, _d = _a.count, count = _d === void 0 ? 0 : _d;
    return (<div className={classNames(classes.base, !count && !more && !selected && classes.disabled, selected && classes.selected, more ? classes.more : classes.classic)} onClick={onClick}>
      {category.name} {!more && "(".concat(count, ")")}
      {selected && <XCircle size={12}/>}
    </div>);
};
export default MultiSelectFullCategory;
